import React from 'react';
import Dialog from '../common/Dialog';
import './LibraryArtifactActions.css';

export default function LibraryDownloadMenu({
  open,
  options = [],
  textHint = null,
  busy = false,
  onClose,
  onSelect,
  testId = 'library-download-menu',
  title = '어떤 파일로 받을까요?',
}) {
  return (
    <Dialog
      align="start"
      dragHandle
      onClose={onClose}
      open={open}
      size="sm"
      testId={testId}
      title={title}
    >
      <div className="library-download-menu__list" role="list">
        {options.map((option) => (
          <button
            className="library-download-option"
            data-testid={`library-download-option-${option.id}`}
            disabled={busy}
            key={option.id}
            onClick={() => onSelect(option)}
            role="listitem"
            type="button"
          >
            <span className="library-download-option__label">{option.label}</span>
            <span className="library-download-option__desc">{option.description}</span>
          </button>
        ))}
      </div>
      {textHint ? <p className="library-download-menu__hint">{textHint}</p> : null}
    </Dialog>
  );
}
